import images from './images';
import config from '../config';

const phoSpecial = [
  {
    titleEng: 'Combo Phở/ Special Phở',
    titleVn: 'Steak, brisket, fatty flank, tendon, beef ball',
    price: '$13.5',
  },
  {
    titleEng: 'Beef Ball Phở',
    titleVn: 'Phở bò viên',
    price: '$12.95',
  },
  {
    titleEng: 'Steak Phở',
    titleVn: 'Phở bò tái',
    price: '$12.95',
  },
  {
    titleEng: 'Steak, Flank & Tendon Phở',
    titleVn: 'Phở tái, nạm',
    price: '$12.95',
  },
  {
    titleEng: 'Vegetable & Tofu Phở',
    titleVn: 'Phở rau đậu hủ',
    price: '$12.95',
  },
  {
    titleEng: 'Seafood Phở',
    titleVn: 'Phở hải sản',
    price: '$12.95',
  },
];

const ricePlateSpecial = [
  {
    titleEng: 'Grilled Pork Chops Rice',
    titleVn: 'Cơm sườn nướng',
    price: '$12.95',
  },
  {
    titleEng: "Shaking Beef & Fried Rice",
    titleVn: 'Cơm chiên bò lúc lắc',
    price: '$17.95',
  },
  {
    titleEng: 'Grilled New York Steak Rice',
    titleVn: 'Cơm bò New York',
    price: '$18.95',
  },
  {
    titleEng: 'Sweet & Sour Chicken Rice',
    titleVn: 'Cơm gà xào chua ngọt',
    price: '$16.95',
  },
  {
    titleEng: 'General Tso Chicken Rice',
    titleVn: 'Cơm gà tướng quân',
    price: '$16.95',
  },
  {
    titleEng: 'Mongolian Beef Rice',
    titleVn: 'Cơm bò mông cổ',
    price: '$17.95',
  },
];

const imagesGallery = [
  {
    images: images.gallery1
  },
  {
    images: images.gallery2
  },{
    images: images.gallery3
  },{
    images: images.gallery4
  },{
    images: images.gallery5
  },{
    images: images.gallery6
  },
];

const imagesCategory = [
  {
    image: images.milkteaCategory,
    title: 'Milk Tea',
    url: config.routes.beverage
  },
  {
    image: images.charamCategory,
    title: 'Spring Rolls',
    url: config.routes.springrolls
  },
  {
    image: images.phoCategory,
    title: 'Pho',
    url: config.routes.pho
  },
  {
    image: images.riceCategory,
    title: 'Rice Plates',
    url: config.routes.riceplate
  },
  {
    image: images.otherCategory,
    title: 'Other',
    url: config.routes.menu
  },
];

const imagesCategoryMenu = [
  {
    imageUrl: images.appetizer,
    title: 'Appetizer',
    url: config.routes.appetizers
  },
  {
    imageUrl: images.bevergate,
    title: 'Bevergate',
    url: config.routes.beverage
  },
  {
    imageUrl: images.friedrice,
    title: 'Fried Rice',
    url: config.routes.friedrice
  },
  {
    imageUrl: images.friednoodle,
    title: 'Stir - Fried Noodles',
    url: config.routes.stirfriednoodle
  },
  {
    imageUrl: images.familysize,
    title: 'Family Size',
    url: config.routes.familysize
  },
  {
    imageUrl: images.noodlesoup,
    title: 'Noodles Soup',
    url: config.routes.noodlesoup
  },
  {
    imageUrl: images.phoCategory,
    title: 'Pho',
    url: config.routes.pho
  },
  {
    imageUrl: images.ricevermicellibowl,
    title: 'Rice Vermicelli Bowl',
    url: config.routes.ricevermicellibowl
  },
  {
    imageUrl: images.riceplate,
    title: 'Rice Plate',
    url: config.routes.riceplate
  },
  {
    imageUrl: images.springroll,
    title: 'Spring Rolls',
    url: config.routes.springrolls
  },
];

const menuItemsPageAppetizers = [
  {
    titleEng: 'Shrimp & Pork Crispy Egg Rolls',
    titleVn: 'Chả giò tôm thịt',
    price: '$7.45',
  },
  {
    titleEng: 'Caramelized Wings',
    titleVn: 'Cánh gà chiên nước mắm',
    price: '$17.95',
  },
  {
    titleEng: 'Salt & Pepper Prawns',
    titleVn: 'Tôm rang muối',
    price: '$17.95',
  },
  {
    titleEng: 'Salt & Pepper Calamari',
    titleVn: 'Mực rang muối',
    price: '$17.95',
  },
  {
    titleEng: 'Grilled Beef, Pork, or Chicken Sandwich',
    titleVn: 'Bánh mì bò, gà, hay thịt nướng',
    price: '$6.95',
  },
  {
    titleEng: 'Tofu Sandwich',
    titleVn: 'Bánh mì đậu hủ',
    price: '$6.95',
  },
  {
    titleEng: 'Potstickers',
    titleVn: 'Bánh xếp',
    price: '$7.25',
  },
  {
    titleEng: 'Lotus Root Salad',
    titleVn: 'Gỏi ngó sen tôm thịt',
    price: '$15.95',
  },
  {
    titleEng: 'Lemon Cured Beef Salad',
    titleVn: 'Gỏi bò tái chanh',
    price: '$15.95',
  },
];

const menuItemsPageSpringRolls = [
  {
    titleEng: 'Shrimp & Pork Rolls',
    titleVn: 'Gỏi cuốn tôm thịt',
    price: '$6.95',
  },
  {
    titleEng: 'Tofu Rolls',
    titleVn: 'Gỏi cuốn đậu hủ',
    price: '$6.95',
  },
  {
    titleEng: 'Grilled Pork/ Chicken Rolls',
    titleVn: 'Gỏi cuốn heo/gà nướng',
    price: '$6.95',
  },
];

const menuItemsPageFriedRice = [
  {
    titleEng: 'YangChow Fried Rice',
    titleVn: 'Cơm chiên Dương Châu',
    price: '$13.95',
  },
  {
    titleEng: 'Chicken or Beef Fried Rice',
    titleVn: 'Cơm chiên bò hay gà',
    price: '$13.95',
  },
  {
    titleEng: 'Shrimp Fried Rice',
    titleVn: 'Cơm chiên tôm',
    price: '$14.95',
  },
  {
    titleEng: 'Vegetarian Fried Rice',
    titleVn: 'Cơm chiên rau cải',
    price: '$13.45',
  },
  {
    titleEng: 'Tofu Fried Rice',
    titleVn: 'Cơm chiên đậu hủ',
    price: '$13.45',
  },
];

const menuItemsPagePho = [
  {
    titleEng: 'Add: Fresh egg',
    titleVn: 'Thêm: Trứng tươi',
    price: '$1.5',
  },
  {
    titleEng: 'Side order: Beef balls in broth',
    titleVn: 'Món ăn kèm: Bò viên ngâm nước dùng',
    price: '$5',
  },
  {
    titleEng: 'Combo Phở/Phở đặc biệt',
    titleVn: 'Steak, brisket, fatty flank, tendon, beef ball',
    price: '$13.95',
  },
  {
    titleEng: 'Beef Ball Phở',
    titleVn: 'Phở bò viên',
    price: '$12.95',
  },
  {
    titleEng: 'Chicken Phở',
    titleVn: 'Phở gà',
    price: '$12.95',
  },
  {
    titleEng: 'Steak Phở',
    titleVn: 'Phở tái',
    price: '$12.95',
  },
  {
    titleEng: 'Steak & Brisket Phở',
    titleVn: 'Phở tái chín',
    price: '$12.95',
  },
  {
    titleEng: 'Steak, Flank & Crunchy Flank Phở',
    titleVn: 'Phở tái nạm, vè đòn',
    price: '$12.95',
  },
  {
    titleEng: 'Steak, Flank & Tendon Phở',
    titleVn: 'Phở tái, nạm, gân',
    price: '$12.95',
  },
  {
    titleEng: 'Steak, Flank Phở',
    titleVn: 'Phở tái, nạm',
    price: '$12.95',
  },
  {
    titleEng: 'Vegetable & Tofu Phở',
    titleVn: 'Phở rau đậu hủ',
    price: '$12.95',
  },
  {
    titleEng: 'Shrimp Phở',
    titleVn: 'Phở tôm',
    price: '$13.95',
  },
  {
    titleEng: 'Seafood Phở',
    titleVn: 'Phở hải sản',
    price: '$13.95',
  },
];

const menuItemsPageNoodlesSoup = [
  {
    titleEng: 'Hue Spicy Noodle Soup',
    titleVn: 'Bún bò Huế',
    price: '$13.95',
  },
  {
    titleEng: 'Chicken Glass Noodle Soup',
    titleVn: 'Miến gà',
    price: '$12.95',
  },
  {
    titleEng: 'Seafood Egg or Rice Noolde Soup',
    titleVn: 'Mì hay Hủ tiếu hải sản',
    price: '$13.95',
  },
  {
    titleEng: 'Beef Stew Egg or RIce Noodle Soup',
    titleVn: 'Mì hay Hủ tiếu bò kho',
    price: '$13.95',
  },
  {
    titleEng: 'BBQ Pork & Wonton Egg Noodle Soup',
    titleVn: 'Mì Wonton xá xíu',
    price: '$12.95',
  },
];

const menuItemsRicePlates = [
  {
    titleEng: 'Grilled Pork Chops Rice',
    titleVn: 'Cơm sườn nướng',
    price: '$12.95',
  },
  {
    titleEng: 'Grilled Pork, Meatloaf & Fried Egg Rice',
    titleVn: 'Cơm thịt nướng, chả trứng & trứng chiên',
    price: '$13.95',
  },
  {
    titleEng: 'Crispy Chicken Rice & Fried Egg Rice',
    titleVn: 'Cơm gà roti & trứng chiên',
    price: '$13.95',
  },
  {
    titleEng: 'Shaking Beef & Fried Rice',
    titleVn: 'Cơm chiên bò lúc lắc',
    price: '$17.95',
  },
  {
    titleEng: 'Grilled New York Steak Rice',
    titleVn: 'Cơm bò New York',
    price: '$18.95',
  },
  {
    titleEng: 'Sweet & Sour Chicken Rice',
    titleVn: 'Cơm gà xào chua ngọt',
    price: '$16.95',
  },
  {
    titleEng: 'General Tso Chicken Rice',
    titleVn: 'Cơm gà tướng quân',
    price: '$16.95',
  },
  {
    titleEng: 'Grilled Chicken Rice',
    titleVn: 'Cơm gà nướng',
    price: '$13.95',
  },
  {
    titleEng: 'Mogolian Beef Rice',
    titleVn: 'Cơm bò Mông Cổ',
    price: '$17.95',
  },
  {
    titleEng: 'Crispy Chicken Iron Pot & Fried Rice',
    titleVn: 'Cơm bát bửa gà rô ti',
    price: '$17.95',
  },
  {
    titleEng: 'Grilled Pork Chop Iron Pot & Fried Rice',
    titleVn: 'Cơm bát bửu sườn nướng',
    price: '$17.95',
  },
  {
    titleEng: 'Stir-fry With Sate Sauce Rice',
    titleVn: 'Cơm xào sate',
    price: '$14.95',
  },
  {
    titleEng: 'Sauteed Broccoli Rice',
    titleVn: 'Cơm xào Broccoli',
    price: '$14.95',
  },
  {
    titleEng: 'Sauteed Vegetables Rice',
    titleVn: 'Cơm xào rau',
    price: '$14.95',
  },
];

const menuItemsPageRiceVermiccelliBowls = [
  {
    titleEng: 'Add: Egg roll',
    titleVn: 'Thêm: Trứng cuộn',
    price: '$1.5',
  },
  {
    titleEng: 'Grilled Pork, Chicken, Beef or Tofu Vermicelli',
    titleVn: 'Bún thịt nướng, bò, gà hay đậu hủ',
    price: '$12.95',
  },
  {
    titleEng: 'Sauteed Chicken, Beef or Tofu Vermicelli',
    titleVn: 'Bún bò xào, gà hay đậu hủ',
    price: '$13.95',
  },
  {
    titleEng: 'Grilled Prawns & Pork Vermicelli',
    titleVn: 'Bún tôm & thịt nướng',
    price: '$13.95',
  },
  {
    titleEng: 'Egg Rolls Vermiccelli',
    titleVn: 'Bún chả giò',
    price: '$12.95',
  },
];

const menuItemsPageFamilySize = [
  {
    titleEng: 'Sweet & Sour Fish Soup',
    titleVn: 'Canh chua cá Bông lau',
    price: '$18.95',
  },
  {
    titleEng: 'Sweer & Sour Fish or Prawn Soup',
    titleVn: 'Canh chua cá hoặc tôm',
    price: '$20.95',
  },
  {
    titleEng: 'Caramelized Catfish',
    titleVn: 'Cá kho tộ',
    price: '$18.95',
  },
  {
    titleEng: 'Ginger Chicken',
    titleVn: 'Gà kho gừng',
    price: '$16.95',
  },
  {
    titleEng: 'Sauteed Lemongrass & Chili Chicken',
    titleVn: 'Gà xào sả ớt',
    price: '$16.95',
  },
  {
    titleEng: 'Ginger & Green Onion Beef',
    titleVn: 'Bò xào hành gừng',
    price: '$17.95',
  },
  {
    titleEng: 'Kungpao Chicken or Beef',
    titleVn: 'Gà hoặc Bò xào Kungpao',
    price: '$16.95',
  },
  {
    titleEng: 'Sauteed Tofu Cubes',
    titleVn: 'Đậu hủ lúc lắc',
    price: '$16.95',
  },
];

const menuItemsPageStirFriedNoodles = [
  {
    titleEng: 'Chicken, Beef, or Tofu Chow Mein',
    titleVn: 'Mì xào bò, gà, hay đậu hủ',
    price: '$16.95',
  },
  {
    titleEng: 'Seafood Chow Mein',
    titleVn: 'Mì xào hải sản',
    price: '$17.95',
  },
  {
    titleEng: 'Chicken, Beef, or Tofu Rice Noodle',
    titleVn: 'Hủ tiếu xào bò, gà, hay đậu hủ',
    price: '$17.95',
  },
  {
    titleEng: 'Seafood Rice Noodle',
    titleVn: 'Hủ tiếu xào hải sản',
    price: '$17.95',
  },
  {
    titleEng: 'Pad Thai',
    titleVn: '(Shrimp/Chicken/Beef)',
    price: '$17.95',
  },
];

const menuItemsPageBeverages = [
  {
    titleEng: 'Iced tea',
    titleVn: 'Trà đá',
    price: '$1.45',
  },
  {
    titleEng: 'Hot tea',
    titleVn: 'Trà nóng',
    price: '$2.45',
  },
  {
    titleEng: 'Coke',
    titleVn: '',
    price: '$2.25',
  },
  {
    titleEng: 'Diet Coke',
    titleVn: '',
    price: '$2.25',
  },
  {
    titleEng: 'Sprite',
    titleVn: '',
    price: '$2.25',
  },
  {
    titleEng: 'Dr Pepper',
    titleVn: '',
    price: '$2.25',
  },
  {
    titleEng: 'Pepsi',
    titleVn: '',
    price: '$2.25',
  },
  {
    titleEng: 'Iced/Hot Black Coffee',
    titleVn: 'Café đen đá/nóng',
    price: '$5.45',
  },
  {
    titleEng: 'Iced/Hot Milk Coffee',
    titleVn: 'Café sữa đá/nóng',
    price: '$5.45',
  },
  {
    titleEng: 'Fresh Lemonade',
    titleVn: 'Nước đá chanh',
    price: '$5.45',
  },
  {
    titleEng: 'Salted Lemonade',
    titleVn: 'Chanh muối',
    price: '$5.45',
  },
  {
    titleEng: 'Soda Lemonade',
    titleVn: 'Soda chanh',
    price: '$5.45',
  },
  {
    titleEng: 'Soda Salted Lemonade',
    titleVn: 'Soda chanh muối',
    price: '$5.45',
  },
  {
    titleEng: 'Thai Tea',
    titleVn: 'Trà Thái',
    price: '$5.45',
  },
  {
    titleEng: 'Sugarcane Juice',
    titleVn: 'Nước mía',
    price: '$6.45',
  },
];

const menuNavbarDetails = [
  {
    label: 'Appetizers',
    url: config.routes.appetizers
  },
  {
    label: 'Spring Rolls',
    url: config.routes.springrolls
  },
  {
    label: 'Fried Rice',
    url: config.routes.friedrice
  },
  {
    label: 'Phở',
    url: config.routes.pho
  },
  {
    label: 'Noodles Soup',
    url: config.routes.noodlesoup
  },
  {
    label: 'Rice Plates',
    url: config.routes.riceplate
  },
  {
    label: 'Rice Vermicelli Bowls',
    url: config.routes.ricevermicellibowl
  },
  {
    label: 'Family Size',
    url: config.routes.familysize
  },
  {
    label: 'Stir-Fried Noodles',
    url: config.routes.stirfriednoodle
  },
  {
    label: 'Beverage',
    url: config.routes.beverage
  },
];

export default { phoSpecial, 
  ricePlateSpecial, 
  imagesGallery, 
  imagesCategory, 
  imagesCategoryMenu, 
  menuItemsPageAppetizers,
  menuItemsPageSpringRolls,
  menuItemsPageFriedRice,
  menuItemsPagePho,
  menuItemsPageNoodlesSoup,
  menuItemsRicePlates,
  menuItemsPageRiceVermiccelliBowls,
  menuItemsPageFamilySize,
  menuItemsPageStirFriedNoodles,
  menuItemsPageBeverages,
  menuNavbarDetails,
 };
